const Empty = ({ message }) => {
  return <p className="empty">{message}</p>;
};

export default Empty;
